var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6124 2.81334L7.27909 5.56001C5.87909 6.09334 4.73242 7.74668 4.73242 9.25334V20.0533C4.73242 21.1333 5.43909 22.56 6.30576 23.2L13.6391 28.68C14.9324 29.6533 17.0524 29.6533 18.3458 28.68L25.6791 23.2C26.5458 22.5467 27.2524 21.1333 27.2524 20.0533V9.25334C27.2524 7.76001 26.1058 6.09334 24.7058 5.57334L17.3724 2.82668C16.6258 2.53334 15.3724 2.53334 14.6124 2.81334Z",
    fill: "#8392A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3327 13.9998C19.3327 12.1598 17.8393 10.6665 15.9993 10.6665C14.1593 10.6665 12.666 12.1598 12.666 13.9998C12.666 15.4932 13.6527 16.7332 14.9993 17.1598V20.6665C14.9993 21.2132 15.4527 21.6665 15.9993 21.6665C16.546 21.6665 16.9993 21.2132 16.9993 20.6665V17.1598C18.346 16.7332 19.3327 15.4932 19.3327 13.9998Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.7912fe059df811143fa8b3dd0cafcd26.svg";
export { ForwardRef as ReactComponent };